export default __webpack_public_path__ + "static/pointing-at-laptop-d82fadb44865876cf066e1aefe9793f6.png";